import { useContext } from "react";
import { SecondarySidebarContext } from "@/shared/ui/layout/secondarySidebarContext";

export function useSecondarySidebar() {
  const context = useContext(SecondarySidebarContext);
  if (!context) {
    throw new Error("useSecondarySidebar must be used inside SecondarySidebarProvider");
  }
  return context;
}
